import React, {useEffect, useState} from 'react';

import {
    MetaInformationApi,
    UserConfigApi,
    CustomerReferenceCodeVm,
    UserConfigurationVm,
} from '../generated/apiclient';
import {showToastAlert} from '../functions/alerts';
import {useModal} from 'react-use-modal';
import TransferList from './common/TransferList';
import {
    Container,
    CardHeader,
    CardContent,
    CardActions,
    Card,
    Button,
    Typography,
} from '@mui/material';
import {useApiConfig} from '../ApiConfig';
import {loadPaylogikUser} from '../redux/store/authSlice';
import {useDispatch} from 'react-redux';

export default function UserSettings(props) {
    const apiConfig = useApiConfig();
    const [refCodes, setRefCodes] = useState<CustomerReferenceCodeVm[]>();
    const [userConfig, setUserConfig] = useState<UserConfigurationVm>();
    const [selectedRefCodes, setSelectedRefCodes] = useState([]);
    const {showModal, closeModal} = useModal();

    useEffect(() => {
        const ilf = async () => {
            //@ts-ignore
            const metaApi = new MetaInformationApi(await apiConfig);
            //@ts-ignore
            const userConfigApi = new UserConfigApi(await apiConfig);
            metaApi
                .getCustomerDataEntryCodesForUser()
                .then((rc) => setRefCodes(rc.data));
            userConfigApi.getMyConfig().then((rc) => {
                const config = rc.data;
                setUserConfig(config);
                setSelectedRefCodes(config.invoiceResearchCustomColumns);
            });
        };

        ilf();
    }, []);

    const onSelectionChanged = (e) => {
        setSelectedRefCodes(e);
        setUserConfig((prev) => {
            return {...prev, invoiceResearchCustomColumns: e};
        });
    };

    const dispatch = useDispatch();

    const saveUserConfig = async () => {
        //@ts-ignore
        const userConfigApi = new UserConfigApi(await apiConfig);

        userConfig.invoiceResearchCustomColumns =
            userConfig.invoiceResearchCustomColumns.map((i, idx) => {
                i.displayOrder = idx;
                return i;
            });

        await userConfigApi.saveMyConfig(userConfig);
        dispatch(loadPaylogikUser());

        showToastAlert(
            'Successfully saved Reference columns.',
            null,
            'success',
            showModal,
            closeModal
        );
    };

    return (
        <Container>
            <h3>Welcome to user settings</h3>

            <Card>
                <CardHeader title="Invoice Research Reference Codes"></CardHeader>
                <CardContent>
                    <Typography>
                        Select the reference codes you would like to appear in
                        the invoice research data grid in addition to the
                        standard columns
                    </Typography>

                    <TransferList
                        sourceData={refCodes || []}
                        value={selectedRefCodes || []}
                        onChange={onSelectionChanged}
                        render={(item) => item.name}
                        keySelector={(item) => item.code}
                    />
                </CardContent>
                <CardActions>
                    <Button onClick={saveUserConfig}>Save</Button>
                </CardActions>
            </Card>
        </Container>
    );
}
